/** @flow */
import React, { Fragment } from 'react';
import type { RowRendererParams } from './types';
import { AccentColor } from 'helpers/AccentColorHelper';

/**
 * Default row renderer for Table.
 */
export default function defaultRowRenderer({
  className,
  columns,
  index,
  key,
  onRowClick,
  onRowDoubleClick,
  onRowMouseOut,
  onRowMouseOver,
  onRowRightClick,
  rowData,
  style,
}: RowRendererParams) {
  const a11yProps = {};

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = event => onRowClick({ event, index, rowData });
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = event => onRowDoubleClick({ event, index, rowData });
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = event => onRowMouseOut({ event, index, rowData });
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = event => onRowMouseOver({ event, index, rowData });
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = event => onRowRightClick({ event, index, rowData });
    }
  }

  if (rowData.tableHeader) {
    style['color'] = AccentColor();
  } else {
    style['cursor'] = 'pointer';
  }

  style['borderRadius'] = '6px';

  return (
    <div {...a11yProps} className={className} key={key} role="row" style={style}>
      <Fragment>
        {rowData.tableHeader && (
          <div style={{ padding: '0 12px' }}>
            {' '}
            <h5 style={{ margin: 0, fontSize: '15px', fontFamily: 'Circular-Black' }}>
              {rowData.tableHeader}
            </h5>{' '}
          </div>
        )}
        {!rowData.tableHeader && columns}
      </Fragment>
    </div>
  );
}
